import React from "react";
import { useSystemPropertyFilterStringValue } from "../../../state/FilterContext";

interface SystemFilterProps {
    name: string,
}

/***
 * A source component that returns the value of a system filter.
 * 
 * Params:
 *      name: The name of the system filter
 */
export const SystemFilter = React.memo(function SystemFilter({ name }: SystemFilterProps): React.ReactElement {
    const systemProperty = useSystemPropertyFilterStringValue(name);
    return <>{systemProperty}</>;
});